/**
 * workflowPathUtils.ts — workflow_path 分段与父子路径推导
 *
 * 多层 nested 场景（Prep → 子流并行 → Finalize）下，不得只切第一个 `>`；
 * 宿主 stage / 子流前缀均基于完整 segment 链推导。
 */

/** `demo-nested>parallel_review>inner` → ['demo-nested', 'parallel_review', 'inner'] */
export function splitWorkflowPathSegments(workflowPath: string): string[] {
  return workflowPath.split('>').filter(Boolean);
}

/** 去掉末段后的父路径；单段根 workflow 返回 null。 */
export function parentWorkflowPath(workflowPath: string): string | null {
  const segments = splitWorkflowPathSegments(workflowPath);
  if (segments.length <= 1) return null;
  return segments.slice(0, -1).join('>');
}

/** 路径末段（当前嵌套 scope 名）。 */
export function lastWorkflowPathSegment(workflowPath: string): string | null {
  const segments = splitWorkflowPathSegments(workflowPath);
  return segments.length > 0 ? segments[segments.length - 1]! : null;
}

/** path 是否为 ancestor 的严格子路径（按 segment 前缀，避免字符串误匹配）。 */
export function isWorkflowPathUnderAncestor(
  workflowPath: string,
  ancestorPath: string,
): boolean {
  if (workflowPath === ancestorPath) return false;
  const prefix = `${ancestorPath}>`;
  return workflowPath.startsWith(prefix);
}

/** path 是否在 ancestor 下（含自身）。 */
export function isWorkflowPathEqualOrUnder(
  workflowPath: string,
  ancestorPath: string,
): boolean {
  return workflowPath === ancestorPath || isWorkflowPathUnderAncestor(workflowPath, ancestorPath);
}
